/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderMinusIcon24Solid = forwardRef('FolderMinusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a2 2 0 0 1 2-2h4.868a2 2 0 0 1 1.715.971l.399.665a.75.75 0 0 0 .643.364H18a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V5Zm6.69 7a1 1 0 0 0 0 2h6.62a1 1 0 1 0 0-2H8.69Z" })));
});
